import getLandingPageLogosSorted from '@/utils/landing-page/getLandingPageLogosSorted';
export default {
    name: 'Logos',
    data: () => ({
        logos: {
            paths: getLandingPageLogosSorted(),
            sections: 0,
            sectionsRemainder: 0,
            sectionSize: 8,
            lastSection: 0,
            s3BasePath: `${process.env.VUE_APP_STATIC_BASE_URL}/landing-2020/logos/`
        },
        mobileLogos: {
            paths: getLandingPageLogosSorted(),
            sections: 0,
            sectionsRemainder: 0,
            sectionSize: 4,
            lastSection: 0,
            s3BasePath: `${process.env.VUE_APP_STATIC_BASE_URL}/landing-2020/logos/`
        },
        carouselTimeout: 8000
    }),
    created() {
        this.logos.sections = parseInt(this.logos.paths.length / this.logos.sectionSize);
        this.logos.sectionsRemainder = this.logos.paths.length % this.logos.sectionSize;
        this.logos.lastSection = this.logos.sectionSize * this.logos.sections;

        this.mobileLogos.sections = parseInt(this.mobileLogos.paths.length / this.mobileLogos.sectionSize);
        this.mobileLogos.sectionsRemainder = this.mobileLogos.paths.length % this.mobileLogos.sectionSize;
        this.mobileLogos.lastSection = this.mobileLogos.sectionSize * this.mobileLogos.sections;
    }
};
